import axios from 'axios'
// import store from '../store'
// import storage from 'store'
// import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
// import { ACCESS_TOKEN } from '@/store/mutation-types'
import nProgress from 'nprogress'
import 'nprogress/nprogress.css'
// import { AxiosUrl } from './common'
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    // 从 localstorage 获取 token

    // const token = storage.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      // notification.error({
      //   message: '禁止访问',
      //   description: data.message
      // })
    }
    if (error.response.status === 500) {
      // notification.error({
      //   message: '服务器内部错误',
      //   description: data.message
      // })
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      // notification.error({
      //   message: '未授权',
      //   description: '未授权'
      // })
      // if (token) {
      //   store.dispatch('Logout').then(() => {
      //     setTimeout(() => {
      //       window.location.reload()
      //     }, 1500)
      //   })
      // }
    }
  } else {
    // notification.error({
    //   message: "错误",
    //   description:
    //     ((error.response || {}).data || {}).message || "请求出现错误，请稍后再试",
    //   duration: 4,
    // });
  }

  nProgress.done()
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  nProgress.start()
  // const token = storage.get(ACCESS_TOKEN)
  // eslint-disable-next-line no-unused-expressions
  config.headers
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  // if (token) {
  //   config.headers = {
  //     'Authorization': 'Bearer ' + token,
  //     // 'Content-Type': 'application/json;charset=UTF-8'
  //   }
  // }

  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  nProgress.done()
  if (response.data.header.resultType !== 1) {
    // notification.error({
    //   message: '错误',
    //   description: response.data.header.msg
    // })
    return Promise.reject(response.data.header.msg)
    // const err = new Error(response.data.header.msg);
    // err.data = response.data
    // err.response = response

    // throw err
  } else {
    return response.data.body
  }
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}



// WEBPACK FOOTER //
// ./src/utils/request.js